import React from 'react'
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconCalendar } from '../../../../../../assets/calendar-icon.svg';
import HeaderIconsGroup from '../shared/HeaderIconsGroup';

const RecentMeasurementsCard = ({ isLoan, isIgr, IconSatis, IconExcl, IconMult, mp }) => {
    const { t } = useTranslation();

    return (
        <div className="card-early">
            <div className='card-early-flex'>
                <p className='title-cards-early'><b>{t('extended_report.projects_with_recent_measurements')} </b></p>
                <div className='card-title-flex '>
                    <div className='icon-position'>
                        <IconCalendar />
                    </div>
                    <p>{t('extended_report.last_3_years')}</p>
                </div>
            </div>
            <HeaderIconsGroup
                showValues={Boolean(isLoan | isIgr)}
                projectsLabel={t('one_pager_report.projects')}
                items={[
                    {
                        Icon: IconSatis,
                        text: t('extended_report.ext_not_alert'),
                        value: mp.RecentIssuses.satisfactory,
                    },
                    {
                        Icon: IconExcl,
                        text: t('extended_report.1_2_alerts_problems'),
                        value: mp.RecentIssuses.warning,
                    },
                    {
                        Icon: IconMult,
                        text: t('extended_report.alerts_problems'),
                        value: mp.RecentIssuses.alert,
                    },
                ]}
            />
        </div>
    )
}

export default RecentMeasurementsCard